import styled from 'styled-components';

import { breakpoints } from '../theme';

const InfoList = styled.ul`
  max-width: 600px;
  margin-top: 1.125em;
  padding: 0;
  list-style-type: none;
  li {
    display: flex;
    align-items: flex-start;
    margin: 0;
    word-break: break-word;
    &:not(:last-child) {
      margin-bottom: 12px;
    }
    &::before {
      content: none;
    }
  }
  svg {
    transform: translateY(0.875em) translateY(-50%);
    flex: 0 0 auto;
    width: 18px;
    margin-right: 12px;
    vertical-align: middle;
  }
  @media (min-width: ${breakpoints[0]}) {
    li {
      display: inline-flex;
      vertical-align: top;
      width: ${({ columns = 2 }: { columns: number }) => 100 / columns}%;
      padding-right: 20px;
    }
  }
`;
export default InfoList;
